import BaseService from '@/services/BaseService'
import { WbEnvironments } from '@interco/inter-webview-bridge'

export type RetentionBottomsheetOutcome = 'accepted' | 'rejected' | 'dismissed'

declare global {
  interface Window {
    dataLayer: Content[]
  }
}

interface Content {
  ref_figma?: string
  content_id?: string
  screen?: string
  content_action?: string
  seguro_fgts_premiavel?: string
  price?: number
  currency?: string
  autorizacao?: boolean
  product?: string
  origem?: string
  event: Events
  fluxo: 'ALTERNATIVO' | 'NORMAL'
  value?: number
  adjust_event_token?: string
  ref_type?: string
  action_id?: string
  utmCampaign?: string
  cpf?: string
  /** Mirrors native TAC / Error route state for segmentation (snake_case for analytics payload). */
  state_error_type?: string
  raw_api_message_snippet?: string
  http_status?: string
  response_extraction_failed?: string
  retention_bottomsheet_outcome?: RetentionBottomsheetOutcome
}

export default {
  add: (value: Content) => {
    window?.dataLayer.push({ ...value, origem: 'novo_simulador_v2' })
    if (BaseService.getEnvironment() !== WbEnvironments.BROWSER) {
      BaseService.sendAnalyticsEvent({
        name: value.event,
        params: {
          ...value,
          value: String(value?.value),
          autorizacao: String(value?.autorizacao),
          price: String(value?.price),
          utm_campaign: value?.utmCampaign || '',
          adjust_event_token:
            value.event === Events.ANTECIPACAO_FGTS_SUCESSO
              ? '8oj5b4'
              : value?.adjust_event_token || '',
        },
      })
    }
  },
}

export enum Actions {
  CLIQUE = 'clique',
  CARREGAR_PAGINA = 'Tela carregada',
  DADOS_CARREGADO = 'Dados carregado',
  FECHAR = 'fechar',
}

export enum Events {
  ANTECIPACAO_FGTS = 'ANTECIPACAO_FGTS',
  FAQ_DUVIDAS = 'FAQ_DUVIDAS',
  HEADER = 'HEADER',
  ANTECIPACAO_FGTS_SUCESSO = 'ANTECIPACAO_FGTS_SUCESSO',
  TOGGLE_VIDA_FGTS = 'TOGGLE_VIDA_FGTS',
  RETAINMENT_BOTTOMSHEET_CTA = 'RETAINMENT_BOTTOMSHEET_CTA',
  RETAINMENT_BOTTOMSHEET_SHOWED = 'RETAINMENT_BOTTOMSHEET_SHOWED',
  AUTOMATICO_ACESSO = 'FGTS_AUTO_ACESSO',
  LIMITES = 'FGTS_MAIS_LIMITE_LP',
  RASPA_SALDO = 'RASPA_SALDO_FGTS',
  RASPA_SALDO_FGTS_ERRO = 'RASPA_SALDO_FGTS_ERRO',
}
